export default {
  apiPrefix: '/v1/',
  apiHost: 'http://localhost:8080',

  get apiUrl() {
    return this.apiHost + this.apiPrefix;
  },
};
